
import { ClientDiscount } from "@/domain/entities/ClientRegistration";
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
  name: "modalDiscount",
  props: {
    modelValue: { type: Boolean, required: true },
    data: {
      type: Object as PropType<ClientDiscount>,
      default: () => new ClientDiscount()
    }
  },
  emits: ["update:modelValue", "see-proof"],
  setup(props, { emit }) {
    const visible = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v)
    });

    return {
      visible
    };
  }
});
